<template>
  <div class="page">
    <div class="c-source-form" v-if="data.property_values">
      <el-form inline>
        <div class="content">
          <el-form-item label="属性名">
            <el-input disabled v-model="data.name"></el-input>
          </el-form-item>
          <div class="form-group-wrap">
            <div class="form-group" v-for="(item, index) in data.property_values" :key="'属性值_' + index">
              <el-form-item label="属性值">
                <el-input v-model="data.property_values[index].value"></el-input>
              </el-form-item>
              <el-color-picker v-if="data.name === '颜色'" v-model="data.property_values[index].color_value"></el-color-picker>
              <el-button type="text" @click="handleRemoveValue(index, data.property_values[index].id)">删除</el-button>
            </div>
          </div>
          <el-form-item class="btn-group">
            <el-button type="primary" @click="handleAddValue">添加属性</el-button>
          </el-form-item>
        </div>
        <el-form-item class="btn-group">
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class PropertynamesEdit extends Vue {

  data = {}
  removedPropertyValues = []

  async mounted() {
    this.data = await this.$request.get(`/property_names/${this.$route.params.id}`);
  }

  handleRemoveValue(index, propertyValueId) {
    let { data: { property_values }, removedPropertyValues } = this

    const removedData = property_values.splice(index, 1)[0]
    if (propertyValueId) {
      removedData['_destroy'] = 1;
      removedPropertyValues.push(removedData);
    }
  }

  handleAddValue() {
    this.data.property_values.push({ value: '', color_value: '' });
  }

  async onSubmit() {
    const { data: { property_values }, removedPropertyValues } = this;
    const id = this.$route.params.id;
    const propertyValues = property_values.concat(removedPropertyValues);

    await this.$autoLoading(
      this.$request.put(`/property_names/${id}`, { name: this.data.name, property_values_attributes: propertyValues })
    );
    this.$message.success('修改规格成功');
    this.$router.push({ name: 'property_names.show', params: { id } });
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .c-source-form .form-group-wrap {
    width: 700px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .form-group {
      width: 50%;
    }
  }
</style>
